export default function LoginController(
    $window,
    $location,
    $rootScope,
    $scope,
    $state,
    $q,
    loginFactory,
    umbracoCredentials,
    adminLink,
    authService,
    userService,
    locationService,
    screenDetectionService,
    l10nService,
    themesService,
) {
        'ngInject';
        const vm = this;

        Object.assign(vm, {
            submitLogin,
            submitLoginSSO,
            getTooltipSSO,
            getTooltip,
            getTooltipPlacement,
            isPasswordErrorVisible,
            resetInvalidUserError,
            loginFailed: false,
        });

        $scope.model = {};
        vm.invalidUser = false;
        $scope.showDepartments = false;
        $scope.isVisible = !umbracoCredentials;
        $scope.departments = [];

        $scope.submitLogin = submitLogin;
        $scope.selectDepartment = selectDepartment;

        themesService.applyThemeFromRequest();

        if (authService.isLoggedIn() && adminLink && userService.isAdmin()) {
            return loginFactory.goToAdmin();
        }

        function getTooltipPlacement() {
            return screenDetectionService.isMobile() ? 'top' : 'right';
        }

        function getToken(userCredentials, isExternalLogin) {
            loginFactory.getToken(userCredentials)
                .then((tokens) => {
                    if (!tokens.accessToken) {
                        vm.invalidUser = true;
                        return vm.invalidUser;
                    }

                    loginFactory.fetchData(tokens)
                        .then(() => {
                            if (isExternalLogin) {
                                const isForCurrentUser = true;
                                loginFactory.fetchDepartments(userCredentials, isForCurrentUser)
                                    .then(proceedLogin);
                            } else {
                                proceedLogin();
                            }

                            function proceedLogin() {
                                const lastState = locationService.getSavedHash();
                                if (adminLink && userService.isAdmin()) {
                                    return loginFactory.goToAdmin();
                                } else if (lastState) {
                                        redirectToSavedUrl(lastState);
                                    } else {
                                        $state.go('main.flights.roundtrip', {}, {reload: true});
                                    }
                            }
                        });
                });
        }

        function redirectToSavedUrl(url) {
            if (urlWithNoParams(url)) {
                $location.path(url.slice(1, url.length));
            } else {
                const [urlString, query] = url.split('?');
                const params = locationService.parseUrlParams(query);
                $location.path(urlString.slice(1)).search(params);
            }
        }

        function urlWithNoParams(url) {
            return url.indexOf('?') === -1;
        }

        if (umbracoCredentials) {
            getToken(umbracoCredentials, true);
        }

        function submitLogin(data) {
            vm.invalidUser = false;
            vm.loginFailed = false;

            const isForCurrentUser = false;

            loginFactory.fetchDepartments(data, isForCurrentUser)
                .then((departmentList) => {
                    if (!departmentList.length) {
                        return $q.reject();
                    }

                    if (departmentList.length === 1) {
                        return $scope.selectDepartment(departmentList.shift());
                    }

                    $scope.showDepartments = true;
                    $scope.departments = departmentList;
                })
                .catch((rejection) => {
                    if (rejection && rejection.status === 400) {
                        vm.invalidUser = true;
                    } else {
                        vm.loginFailed = true;
                    }
                });
        }
        function isPasswordErrorVisible() {
            return vm.loginForm.$submitted && vm.loginForm.password.$invalid;
        }
        function resetInvalidUserError() {
            vm.invalidUser = false;
        }

        function getTooltip() { // eslint-disable-line
            let tooltipText;
            if (vm.loginForm.$submitted) {
                const error = vm.loginForm.email.$error;
                if (error) {
                    if (error.pattern) {
                        tooltipText = 'Please provide valid email address.';
                    }
                    if (error.required) {
                        tooltipText = 'Email address is required.';
                    }
                }
            }

            if (!tooltipText && vm.invalidUser) {
                tooltipText = 'The email or password you entered is incorrect.';
            }
            if (!tooltipText && vm.loginFailed) {
                tooltipText = 'Please retry later or contact the technical support.';
            }

            return tooltipText
                ? l10nService.localize(tooltipText)
                : null;
        }

        function getTooltipSSO() { // eslint-disable-line
            let tooltipText;
            if (vm.loginFormSSO.$submitted) {
                const error = vm.loginFormSSO.email_sso.$error;
                if (error) {
                    if (error.pattern) {
                        tooltipText = 'Please provide valid email address.';
                    }
                    if (error.required) {
                        tooltipText = 'Email address is required.';
                    }
                }
            }
            if (!tooltipText && vm.invalidUserSSO) {
                tooltipText = 'The email you entered is incorrect.';
            }
            if (!tooltipText && vm.loginFailedSSO) {
                tooltipText = 'Please retry later or contact the technical support.';
            }
            if (!tooltipText && vm.inactiveSSO) {
                tooltipText = 'Your internal account is not supported. Please log in with your Key Travel account.';
            }

            return tooltipText
                ? l10nService.localize(tooltipText)
                : null;
        }

        function successSSOcallback(result) {
            vm.inactiveSSO = result.IsActive && !result.SingleSignOnId;
            vm.loginFailedSSO = !result.IsActive;

            if (result.SingleSignOnId) {
                const TRIP_ID_POSITION = 3;
                const DEPARTMENT_ID_POSITION = 4;
                const lastState = locationService.getSavedHash();
                const host = $location.host();
                const protocol = $location.protocol();

                const siteUrl = 'https://sp.keytravel.com/openathens/login?';
                const entityId = `entityID=${result.SingleSignOnId}&`;
                const tripId = `tripId=${lastState.split('/')[TRIP_ID_POSITION]}&`;
                const departmentId = `departmentId=${lastState.split('/')[DEPARTMENT_ID_POSITION]}&`;
                const atlasUrl = 'atlasUrl=' + encodeURIComponent(`${protocol}://${host}`);

                $rootScope.isLoading = true;
                $window.location.href = siteUrl + entityId + tripId + departmentId + atlasUrl;
            }
        }
        function errorSSOhandler(rejection) {
            if (rejection && rejection.status === 400) {
                vm.invalidUserSSO = true;
            } else {
                vm.loginFailedSSO = true;
            }
        }

        function submitLoginSSO(email) {
            vm.loginFailedSSO = false;
            vm.inactiveSSO = false;
            vm.invalidUserSSO = false;
            loginFactory.loginSSO(email)
                .then(({data}) => successSSOcallback(data))
                .catch((rejection) => errorSSOhandler(rejection));
        }

        function selectDepartment(department) {
            const userCredentials = {
                user: department.UserId,
                password: department.Token,
                countryCode: department.CountryCode,
                contactPermissionId: department.ContactPermissionId,
            };

            $scope.model.department = department;
            getToken(userCredentials, false);
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/controllers/loginController.js